import addressService from './addressService'
export * from './addressService'

export default addressService
